<template>
  <div class="header">
    <div id="header">
      <div class="fl">
        <div class="sidebar-header">
          <i class="el-icon-menu" @click="toggleCollapse"></i>
        </div>
      </div>
      <div class="fr header-right">
        <span class="user_name" v-text="this.$store.state.Auth.name"></span>
        <span class="pull-right logout"  @click="logout">退出</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
  },
  watch: {
    $route (to, from) {
    }
  },
  data () {
    return {
      activeIndex: '1',
      user: ''
    }
  },
  methods: {
    toggleCollapse () {
      console.log('切换')
      this.$store.dispatch('toggleCollapse')
    },
    logout () {
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$store.dispatch('logout').then(() => {
          this.$router.push({name: 'Login'})
        })
      }).catch(() => {
        console.log('cancel')
      })
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
.headerlogo{
  width: 188px;
  line-height: 90px;
  margin-right: 127px;
}
.user_name{
  font-size: 13px;
  color: #ffffff;
  line-height: 62px;
}
.sidebar-header i{
  display: block;
  color: #C0C4CC;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  // background: #ececec;
  text-align: center;
  line-height: 36px;
  margin-left: 13px;
  margin-top: 13px;
  cursor: pointer;
  transform: rotate(180deg);
  font-size: 16px;
}
.sidebar-header i:hover{
  color: #4A99CB;
}
.logout{
  border: 0;
  color: #C0C4CB;
  font-size: 14px;
  line-height: 62px;
  margin-right: 25px;
  padding: 0;
  font-weight: normal;
  float: right;
  margin-left: 15px;
  cursor: pointer;
}
// .logout:hover{
//   background: none;
//   color: #20a0ff;
// }
</style>



// WEBPACK FOOTER //
// src/components/Public/Header.vue